<template>
    <div class="Com_view">
        <div class="box_header">
            <!-- <el-image :src="require('../assets/image/bg_2.jpg')"></el-image> -->
        </div>
        <div class="box_section">
            <div class="box_product">
                <div class="box_title wow animate__animated animate__fadeInUp" style="animation-delay: 0.3s;">
                    <span>欧力美®医用弹力套</span>
                </div>
                <div class="box_image">
                    <li style="animation-delay: 0.6s;" class="wow animate__animated animate__fadeInUp"><el-image
                            :src="require('../assets/product/产品展示/欧力美-医用弹力套/下颌套.jpg')"></el-image>
                        <div class="box_mask">
                            <span>下颌套</span>
                        </div>
                    </li>
                    <li style="animation-delay: 0.9s;" class="wow animate__animated animate__fadeInUp"><el-image
                            :src="require('../assets/product/产品展示/欧力美-医用弹力套/塑身裤.jpg')"></el-image>
                        <div class="box_mask">
                            <span>塑身裤</span>
                        </div>
                    </li>
                    <li style="animation-delay: 1.2s;" class="wow animate__animated animate__fadeInUp"><el-image
                            :src="require('../assets/product/产品展示/欧力美-医用弹力套/胸腹衣.jpg')"></el-image>
                        <div class="box_mask">
                            <span>胸腹衣</span>
                        </div>
                    </li>
                </div>
            </div>
            <div class="box_product">
                <div class="box_title wow animate__animated animate__fadeInUp" style="animation-delay: 0.3s;">
                    <span>痕丽®烧伤定制</span>
                </div>
                <div class="box_image">
                    <li style="animation-delay: 0.6s;" class="wow animate__animated animate__fadeInUp"><el-image
                            :src="require('../assets/product/产品展示/痕丽-烧伤定制/下肢套.jpg')"></el-image>
                        <div class="box_mask">
                            <span>下肢套</span>
                        </div>
                    </li>
                    <li style="animation-delay: 0.9s;" class="wow animate__animated animate__fadeInUp"><el-image
                            :src="require('../assets/product/产品展示/痕丽-烧伤定制/女式背心套.jpg')"></el-image>
                        <div class="box_mask">
                            <span>女式背心套</span>
                        </div>
                    </li>
                    <li style="animation-delay: 1.2s;" class="wow animate__animated animate__fadeInUp"><el-image
                            :src="require('../assets/product/产品展示/痕丽-烧伤定制/无指手套.jpg')"></el-image>
                        <div class="box_mask">
                            <span>无指手套</span>
                        </div>
                    </li>
                </div>
            </div>
            <div class="box_product">
                <div class="box_title wow animate__animated animate__fadeInUp" style="animation-delay: 0.3s;">
                    <span>必特酷®运动品牌</span>
                </div>
                <div class="box_image">
                    <li style="animation-delay: 0.6s;" class="wow animate__animated animate__fadeInUp"><el-image
                            :src="require('../assets/product/产品展示/必特酷-运动品牌/中筒袜.jpg')"></el-image>
                        <div class="box_mask">
                            <span>中筒袜</span>
                        </div>
                    </li>
                    <li style="animation-delay: 0.9s;" class="wow animate__animated animate__fadeInUp"><el-image
                            :src="require('../assets/product/产品展示/必特酷-运动品牌/小腿套.jpg')"></el-image>
                        <div class="box_mask">
                            <span>小腿套</span>
                        </div>
                    </li>
                    <li style="animation-delay: 1.2s;" class="wow animate__animated animate__fadeInUp"><el-image
                            :src="require('../assets/product/产品展示/必特酷-运动品牌/长筒袜.jpg')"></el-image>
                        <div class="box_mask">
                            <span>长筒袜</span>
                        </div>
                    </li>
                </div>
            </div>
            <div class="box_product">
                <div class="box_title wow animate__animated animate__fadeInUp" style="animation-delay: 0.3s;">
                    <span>蕾丝拜尔®美体塑身衣</span>
                </div>
                <div class="box_image">
                    <li style="animation-delay: 0.6s;" class="wow animate__animated animate__fadeInUp"><el-image
                            :src="require('../assets/product/产品展示/蕾丝拜尔-美体塑身衣/产后提臀裤.jpg')"></el-image>
                        <div class="box_mask">
                            <span>产后提臀裤</span>
                        </div>
                    </li>
                    <li style="animation-delay: 0.9s;" class="wow animate__animated animate__fadeInUp"><el-image
                            :src="require('../assets/product/产品展示/蕾丝拜尔-美体塑身衣/产后连体衣.jpg')"></el-image>
                        <div class="box_mask">
                            <span>产后连体衣</span>
                        </div>
                    </li>
                    <li style="animation-delay: 1.2s;" class="wow animate__animated animate__fadeInUp"><el-image
                            :src="require('../assets/product/产品展示/蕾丝拜尔-美体塑身衣/束腰连体衣.jpg')"></el-image>
                        <div class="box_mask">
                            <span>束腰连体衣</span>
                        </div>
                    </li>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WOW from "wowjs";
export default {
    data() {
        return {
        };
    },
    created() { },
    methods: {},
    mounted() {
        new WOW.WOW().init();
    }
};
</script>

<style lang="less" scoped>
@media all and (max-width: 768px) {
    .Com_view {
        .box_section {
            .box_product {
                width: 90% !important;

                .box_title {
                    font-size: 16px !important;
                }

                .box_image {
                    li {
                        margin: 5px !important;
                    }
                }
            }
        }
    }
}
</style>

<style lang="less" scoped>
.Com_view {
    .box_header {
        height: 30vw;
        min-height: 200px;
        background-image: url('../assets/image/bg_2.jpg');
        overflow: hidden;
        background-repeat: no-repeat;
        background-size:cover;
        background-position:center center;
    }

    .box_section {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 40px 0;
        margin-bottom: 0px;
        padding-bottom: 20px;
        border-bottom: 1px dashed #DCDCDA;

        .box_product {
            width: 70%;
            margin-bottom: 40px;

            .box_title {
                text-align: center;
                margin: 20px 0;
                font-size: 20px;
                color: #666;

                span {
                    position: relative;

                    &::after {
                        position: absolute;
                        content: "";
                        left: -40px;
                        top: 49%;
                        width: 30px;
                        height: 0px;
                        border-top: 1px dashed #c9c9c9;
                    }

                    &::before {
                        position: absolute;
                        content: "";
                        right: -40px;
                        top: 49%;
                        width: 30px;
                        height: 0px;
                        border-top: 1px dashed #c9c9c9;
                    }
                }
            }

            .box_image {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                padding: 20px;
                background: linear-gradient(to left, #6666665a, #6666665a) left top no-repeat,
                    linear-gradient(to bottom, #6666665a, #6666665a) left top no-repeat,
                    linear-gradient(to left, #6666665a, #6666665a) right top no-repeat,
                    linear-gradient(to bottom, #6666665a, #6666665a) right top no-repeat,
                    linear-gradient(to left, #6666665a, #6666665a) left bottom no-repeat,
                    linear-gradient(to bottom, #6666665a, #6666665a) left bottom no-repeat,
                    linear-gradient(to left, #6666665a, #6666665a) right bottom no-repeat,
                    linear-gradient(to left, #6666665a, #6666665a) right bottom no-repeat;
                background-size: 2px 10px, 10px 2px, 2px 10px, 10px 2px;

                li {
                    position: relative;
                    list-style: none;
                    min-width: 150px;
                    flex: 1;
                    box-shadow: 0 2px 5px 1px rgba(183, 192, 206, 0.2);
                    margin: 10px;
                    overflow: hidden;
                    border-radius: 2px;

                    &:hover {
                        .el-image {
                            transform: scale(1.2);
                        }
                    }

                    .box_mask {
                        position: absolute;
                        z-index: 2;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(0, 0, 0, 0.5);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: white;
                        font-size: 14px;
                        letter-spacing: 2px;
                        opacity: 0;
                        transition: all .6s;

                        span {
                            position: relative;
                            display: block;

                            &::after {
                                position: absolute;
                                content: "";
                                width: 120%;
                                background: white;
                                height: 1px;
                                left: -10%;
                                bottom: -5px;
                                transform: scaleX(1);
                                transition: .4s;
                                z-index: 3;
                            }

                            &::before {
                                position: absolute;
                                content: "";
                                width: 120%;
                                background: white;
                                height: 1px;
                                left: -10%;
                                top: -5px;
                                transform: scaleX(1);
                                transition: .4s;
                                z-index: 3;
                            }
                        }

                        &:hover {
                            opacity: 1;

                            span {
                                &::after {
                                    transform: scaleX(0.3);
                                }

                                &::before {
                                    transform: scaleX(0.3);
                                }
                            }
                        }
                    }
                }

                .el-image {
                    width: 100%;
                    height: 100%;
                    transition: all .6s;

                }
            }
        }
    }
}
</style>